enum MembershipSelection {
  OneMonth = 'one-month-membership',
  OneYear = 'one-year-membership',
  CurrentMember = 'current-member',
}

export default MembershipSelection;
